import SectionHeading from '@commons/headings/section'
import Column from '@components/column'
import Row from '@components/row'
import { useState } from 'react'
import LabTestCategory from './labTestCategory'
import SampleTypes from './sampleTypes'
import Button from '@components/button'
import { StyleTabButton } from './style'
const LabTestList = () => {
  const [active, setActive] = useState('labTest')
  const tabs = {
    labTest: {
      Component: LabTestCategory,
    },
    sampleType: {
      Component: SampleTypes,
    },
  }
  const { Component } = tabs[active]
  return (
    <Column styleColumn="margin-top:20px;">
      <SectionHeading title="Category List" />
      <Column styleColumn="margin-top:20px;">
        <Column styleColumn="margin-bottom:10px;">
          <Row colGap={15}>
            <StyleTabButton
              isActive={active == 'labTest'}
              onClick={() => {
                setActive('labTest')
              }}
            >
              Lab Test Category
            </StyleTabButton>
            <StyleTabButton
              isActive={active == 'sampleType'}
              onClick={() => {
                setActive('sampleType')
              }}
            >
              Sample Types
            </StyleTabButton>
          </Row>
        </Column>
        <Component />
      </Column>
    </Column>
  )
}

export default LabTestList
